var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFortnoxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 769 173",
    style: {
      enableBackground: "new 0 0 769 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,12.8H53.8c-27.5,0-46.1,18.6-46.1,46.1v98.8c0,2.8,1.6,4.4,4.4,4.4H34c2.8,0,4.4-1.6,4.4-4.4v-41.1h54.9 c2.8,0,4.4-1.6,4.4-4.4v-21c0-2.8-1.6-4.4-4.4-4.4H38.3V58.2c0-9.2,6.2-15.3,15.3-15.3h39.6c2.8,0,4.4-1.6,4.4-4.4V17.3 C97.7,14.4,96.1,12.8,93.3,12.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.9,39.2c-36.3,0-62.4,27.5-62.4,62.7s26.2,62.7,62.4,62.7s62.4-27.5,62.4-62.7S205.2,39.2,168.9,39.2z  M168.9,135.1c-18.6,0-32.4-13.9-32.4-33.2s13.6-33.2,32.4-33.2s32.4,13.9,32.4,33.2S187.7,135.1,168.9,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.8,41.4h-37.4V12.8c0-2.8-1.6-4.4-4.4-4.4H317c-2.8,0-4.4,1.6-4.4,4.4v28.6h-26.4 c-27.3,0-46.1,18.6-46.1,46.1v70.3c0,2.8,1.6,4.4,4.4,4.4h21.9c2.8,0,4.4-1.6,4.4-4.4V86.6c0-9.2,6.2-15.3,15.3-15.3h26.4v44.8 c0,27.5,18.6,46.1,46.1,46.1h21.9c2.8,0,4.4-1.6,4.4-4.4v-21c0-2.8-1.6-4.4-4.4-4.4h-21.8c-9.2,0-15.3-6.2-15.3-15.3V71.3h37.4 c2.8,0,4.4-1.6,4.4-4.4v-21C385.2,42.8,383.6,41.4,380.8,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449,39.2c-33.2,0-54.9,21.3-54.9,53.8V158c0,2.8,1.6,4.4,4.4,4.4h21.9c2.8,0,4.4-1.6,4.4-4.4V93.1 c0-14.7,9.6-24.2,24.2-24c14.5-0.2,24.2,9.2,24.2,24V158c0,2.8,1.6,4.4,4.4,4.4h21.9c2.8,0,4.4-1.6,4.4-4.4V93.1 C504,60.5,482.2,39.2,449,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.2,39.2c-36.3,0-62.4,27.5-62.4,62.7s26.2,62.7,62.4,62.7c36.3,0,62.4-27.5,62.4-62.7 S611.3,39.2,575.2,39.2z M575.2,135.1c-18.6,0-32.4-13.9-32.4-33.2s13.6-33.2,32.4-33.2c18.6,0,32.4,13.9,32.4,33.2 S593.8,135.1,575.2,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.4,101.6l38.8-38.8c2.1-2.1,2.1-4.1,0-6.2L744,41.3c-2.1-2.1-4.1-2.1-6.2,0L699,80.1l-38.8-38.8 c-2.1-2.1-4.1-2.1-6.2,0l-15.3,15.3c-2.1,2.1-2.1,4.1,0,6.2l38.8,38.8l-39.2,38.8c-2.1,2.1-2.1,4.1,0,6.2l15.3,15.3 c2.1,2.1,4.1,2.1,6.2,0l38.8-38.8l38.8,38.8c2.1,2.1,4.1,2.1,6.2,0l15.3-15.3c2.1-2.1,2.1-4.1,0-6.2L720.4,101.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortnoxWhite);
export default __webpack_public_path__ + "static/media/fortnox_white.959de93da473d1c006bcd75b50f70edd.svg";
export { ForwardRef as ReactComponent };